import { isEnvironmentLocal, isEnvironmentStaging, isEnvironmentProduction } from "../Environment.js";
import { jsx } from "react/jsx-runtime";
import { useRef, useEffect, useCallback } from "react";
import { http } from "msw";
function isDefined(arg) {
  return arg != null;
}
function getMarketingUrl(path = "") {
  const pathWithPrefix = path.startsWith("/") ? path : `/${path}`;
  if (isEnvironmentLocal()) {
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
  }
  if (isEnvironmentStaging()) {
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
  }
  if (isEnvironmentProduction()) {
    return `https://www.color.com${pathWithPrefix}`;
  }
  return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
}
function withDefaultProps(Component, defaultProps) {
  return (props) => /* @__PURE__ */ jsx(Component, { ...defaultProps, ...props });
}
const createMswHandler = (requestHandler, endpoint, options) => {
  const { statusCode = 200, response = {} } = options || {};
  return requestHandler(endpoint, () => {
    return new Response(response ? JSON.stringify(response) : null, {
      status: statusCode,
      headers: {
        "Content-Type": "application/json"
      }
    });
  });
};
const createMswGetHandler = (endpoint, options) => {
  return createMswHandler(http.get, endpoint, options);
};
const createMswPostHandler = (endpoint, options) => {
  return createMswHandler(http.post, endpoint, options);
};
const createMswPatchHandler = (endpoint, options) => {
  return createMswHandler(http.patch, endpoint, options);
};
const createMswHandlerSpy = (requestHandler, endpoint, options) => {
  const { statusCode = 200, response = {} } = options || {};
  let requestQueryParams;
  let requestJsonData;
  let wasCalled = false;
  const handler = requestHandler(endpoint, async ({ request }) => {
    requestQueryParams = new URL(request.url).searchParams;
    try {
      requestJsonData = await request.json();
    } catch {
    } finally {
      wasCalled = true;
    }
    return new Response(response ? JSON.stringify(response) : null, {
      status: statusCode,
      headers: {
        "Content-Type": "application/json"
      }
    });
  });
  return {
    getRequestQueryParams: () => requestQueryParams,
    getRequestJsonData: () => requestJsonData,
    getWasCalled: () => wasCalled,
    handler
  };
};
const createMswGetHandlerSpy = (endpoint, options) => {
  const { getRequestQueryParams, getWasCalled, handler } = createMswHandlerSpy(
    http.get,
    endpoint,
    options
  );
  return {
    getRequestQueryParams,
    getWasCalled,
    handler
  };
};
const createMswPostHandlerSpy = (endpoint, options) => {
  const { getRequestJsonData, getWasCalled, handler } = createMswHandlerSpy(
    http.post,
    endpoint,
    options
  );
  return {
    getPostedValues: getRequestJsonData,
    getWasCalled,
    handler
  };
};
const createMswPutHandlerSpy = (endpoint, options) => {
  const { getRequestJsonData, getWasCalled, handler } = createMswHandlerSpy(
    http.put,
    endpoint,
    options
  );
  return {
    getPutValues: getRequestJsonData,
    getWasCalled,
    handler
  };
};
function useDebounceFn(fn, delay) {
  const timeoutRef = useRef(null);
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [fn, delay]);
  return useCallback(
    (args) => {
      timeoutRef.current = setTimeout(() => fn(args), delay);
    },
    [fn, delay]
  );
}
export {
  createMswGetHandlerSpy as a,
  createMswPostHandler as b,
  createMswGetHandler as c,
  createMswPostHandlerSpy as d,
  createMswPatchHandler as e,
  createMswPutHandlerSpy as f,
  getMarketingUrl as g,
  isDefined as i,
  useDebounceFn as u,
  withDefaultProps as w
};
//# sourceMappingURL=useDebounceFn-CsbfT4_V.js.map
